import React from 'react';
export function Footer() {
  return <footer className="bg-brand-light px-4 py-4 text-center" data-id="element-66" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl space-y-1" data-id="element-67" data-mp="3gfiuujlrgden">
        <p className="text-[11px] font-semibold text-brand-ink sm:text-xs" data-id="element-68" data-mp="3ghc486nrdbqc">
          © 2026 SMART HOME INSTALLER PRO™ — All Rights Reserved.
        </p>
        <p className="text-[11px] font-normal leading-snug text-brand-muted sm:text-xs" data-id="element-69" data-mp="36qhhl16loa4d">
          This training program is provided for educational purposes and is designed to teach Smart
          Home installation principles, automation systems, and professional workflows. Students
          should always follow local electrical regulations, manufacturer guidelines, safety
          standards, and applicable laws when performing any installation.
        </p>
        <p className="text-[11px] font-medium text-brand-muted sm:text-xs" data-id="element-70" data-mp="29z6x2jmuoxjl">
          Terms &amp; Conditions • Privacy Policy • Contact
        </p>
        <p className="text-[11px] font-medium text-brand-muted sm:text-xs" data-id="element-71" data-mp="2ez1nkm2prl44">
          Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="font-semibold text-brand-orange hover:underline" data-id="element-72" data-mp="3la2akxul99wt">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}